import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Authentication/Login";
import PublicLayout from "./Common/Layout/PublicLayout.jsx";
import AppLayout from "./Common/Layout/AppLayout.jsx";
import { AuthContext as VerifyAuthContext } from "./Common/Configurations/AuthContext"; // TEMP-VERIFY-REMOVE
import PromoCode from "./Components/Master/PromoCode.jsx";
const Flights = lazy(() => import("./Components/Flight/Flights"));
const FlightsCompare = lazy(() => import("./Components/Flight/FlightsCompare"));
const SearchFlight = lazy(() => import("./Components/Flight/SearchFlight"));
const SearchCompareFlight = lazy(() => import("./Components/Flight/SearchCompareFlight"));
const CompanyProfile = lazy(() => import("./Components/Master/CompanyProfile"));
const Branch = lazy(() => import("./Components/Master/Branch"));
const Supplier = lazy(() => import("./Components/Master/Supplier"));
const LeadStatus = lazy(() => import("./Components/Marketing/LeadStatus"));
const Users = lazy(() => import("./Components/Master/Users"));
const FlightDetails = lazy(() => import("./Components/Flight/FlightDetails"));
const DestinationType = lazy(() => import("./Components/Master/DestinationType"));
const Destination = lazy(() => import("./Components/Master/Destination"));
const TravelType = lazy(() => import("./Components/Master/TravelType"));
const PackageComponent = lazy(() => import("./Components/Package/CreatePackage"));
const PackageList = lazy(() => import("./Components/Package/PackageList"));
const Marketing = lazy(() => import("./Components/Marketing/Marketing"));
const ReviewFlight = lazy(() => import("./Components/Flight/ReviewFlight"));
const Customer = lazy(() => import("./Components/Master/Customer"));
const Source = lazy(() => import("./Components/Marketing/Source"));
const Lead = lazy(() => import("./Components/Marketing/Lead"));
const LeadCalendar = lazy(() => import("./Components/Marketing/LeadCalendar"));
const Umrah = lazy(() => import("./Components/Umrah/CreateUmrah"));
const UmrahList = lazy(() => import("./Components/Umrah/UmrahList"));
const FlightBookingDetails = lazy(() => import("./Components/Flight/FlightBookingDetails"));
const FlightBookings = lazy(() => import("./Components/Flight/FlightBookings"));
const FlightVoucher = lazy(() => import("./Components/Flight/FlightVoucher"));
const SearchHotel = lazy(() => import("./Components/Hotels/SearchHotels"));
const HotelsList = lazy(() => import("./Components/Hotels/HotelsList"));
const FlightInvoice = lazy(() => import("./Components/Flight/FlightInvoice"));
const SightSeeingSearch = lazy(() => import("./Components/SightSeeing/SightSeeingSearch"));
const SightSeeingProducts = lazy(() => import("./Components/SightSeeing/SightSeeingProducts"));
const SightSeeingProduct = lazy(() => import("./Components/SightSeeing/SightSeeingProduct"));
const HotelDetails = lazy(() => import("./Components/Hotels/HotelDetails"));
const PackageDate = lazy(() => import("./Components/Package/PackageDate"));
const HotelGuests = lazy(() => import("./Components/Hotels/HotelGuests"));
const EnquiryList = lazy(() => import("./Components/Package/EnquiryList"));
const LandingPage = lazy(() => import("./Components/Settings/LandingPage"));
const HotelReview = lazy(() => import("./Components/Hotels/HotelReview"));
const HotelBookings = lazy(() => import("./Components/Hotels/HotelBookings"));
const HotelBookingDetails = lazy(() => import("./Components/Hotels/HotelBookingDetails"));
const HotelVoucher = lazy(() => import("./Components/Hotels/HotelVoucher"));
const HotelInvoice = lazy(() => import("./Components/Hotels/HotelInvoice"));
const FromOrigin = lazy(() => import("./Components/Package/FromOrigin"));
const GroupBookings = lazy(() => import("./Components/Flight/GroupBookings"));
const Dashboard = lazy(() => import("./Components/Dashboard/Dashboard"));
const Hajj = lazy(() => import("./Components/Hajj/CreateHajj"));
const HajjList = lazy(() => import("./Components/Hajj/HajjList"));
const HajjEnquiry = lazy(() => import("./Components/Hajj/HajjEnquiry"));
const UmrahEnquiryList = lazy(() => import("./Components/Umrah/UmrahEnquiryList"));
const FlightReport = lazy(() => import("./Components/Report/FlightReport"));
const HotelReport = lazy(() => import("./Components/Report/HotelReport"));
const FlightGstReport = lazy(() => import("./Components/Report/FlightGstReport"));
const AgentPayments = lazy(() => import("./Components/Companies/AgentPayments"));
const AgentCredits = lazy(() => import("./Components/Companies/AgentCredits"));
const AgentInvoice = lazy(() => import("./Components/Companies/AgentInvoice"));
const SightSeeingBooking = lazy(() => import("./Components/SightSeeing/SightSeeingBooking"));
const SightSeeingBookingDetails = lazy(() => import("./Components/SightSeeing/SightSeeingBookingDetails"));
const ChangePassword = lazy(() => import("./Components/Master/ChangePassword"));
const PackageTemplates = lazy(() => import("./Components/Package/PackageTemplates"));
const SearchVisas = lazy(() => import("./Components/Visas/Visas"));
const Promotions = lazy(() => import("./Components/Marketing/Promotions.jsx"));
const LeadManagementDashboard = lazy(() => import("./Components/Marketing/LeadDashboard.jsx"));
const WebsitePackageList = lazy(() => import("./Components/Package/WebsitePackageList.jsx"));
const LeadStaffReports = lazy(() => import("./Components/Marketing/LeadStaffReports.jsx"));
const CreditHistory = lazy(() => import("./Components/Master/CreditHistory.jsx"));
const VisaRequestReports = lazy(() => import("./Components/Visas/VisaRequestReport.jsx"));
const VisaSupplierReports = lazy(() => import("./Components/Visas/VisaSupplierReport.jsx"));
const SaasRegister = lazy(() => import("./Authentication/SaasRegistration.jsx"));
const ForgotPassword = lazy(() => import("./Authentication/ForgotPassword.jsx"));
const SubscriptionPlan = lazy(() => import("./Components/Companies/SubscriptionPlan.jsx"));
const WebsiteUmrahList = lazy(() => import("./Components/Umrah/WebsiteUmrahList.jsx"));
const WebsiteHajjList = lazy(() => import("./Components/Hajj/WebsiteHajjList.jsx"));
const ConfirmEmail = lazy(() => import("./Authentication/ConfirmEmail.jsx"));
const TaxInformation = lazy(() => import("./Authentication/TaxInformation.jsx"));
const RegistrationPending = lazy(() => import("./Authentication/RegistrationPending.jsx"));
const ChatBotSettings = lazy(() => import("./Components/ChatBot/ChatBotSettings.jsx"));
const WhatsAppCallback = lazy(() => import("./Components/ChatBot/WhatsAppCallback.jsx"));
const SupplierRegister = lazy(() => import("./Authentication/SupplierRegistration.jsx"));
const DMCRegistration = lazy(() => import("./Authentication/DMCRegistration.jsx"));
const VisaProviders = lazy(() => import("./Authentication/VisaProviders.jsx"));
const SupplierTaxInformation = lazy(() => import("./Supplier/SupplierTaxInformation.jsx"));
const SupplierVisaPrices = lazy(() => import("./Supplier/SupplierVisaPrices.jsx"));
const SupplierVisaRequests = lazy(() => import("./Supplier/SupplierVisaRequests.jsx"));
const SightSeeingBookings = lazy(() => import("./Components/SightSeeing/SightSeeingBookings.jsx"));
const ResetPassword = lazy(() => import("./Authentication/ResetPassword.jsx"));
const AboutPage = lazy(() => import("./StaticPages/AboutPage.jsx"));
const FeaturesPage = lazy(() => import("./StaticPages/FeaturesPage.jsx"));
const BlogPage = lazy(() => import("./StaticPages/BlogPage.jsx"));
const BlogDetailPage = lazy(() => import("./StaticPages/BlogDetailPage.jsx"));
const ContactPage = lazy(() => import("./StaticPages/ContactPage.jsx"));
const PrivacyPolicy = lazy(() => import("./StaticPages/PrivacyPolicy.jsx"));
const Terms = lazy(() => import("./StaticPages/Terms.jsx"));
const BookingTermsAndConditions = lazy(() => import("./StaticPages/BookingTermsAndConditions.jsx"));
// import MySubscriptionPlan from "./Components/Master/MySubscriptionPlan.jsx";
const VisaAppointments = lazy(() => import("./Supplier/VisaAppointments.jsx"));
const VisaAppointmentCalendar = lazy(() => import("./Components/Visas/VisaAppointmentCalendar.jsx"));
const Visas = lazy(() => import("./Components/Visas/Visas.jsx"));
const RequestDetails = lazy(() => import("./Components/Visas/RequestDetails.jsx"));
const Requests = lazy(() => import("./Components/Visas/Requests.jsx"));
const BusSearch = lazy(() => import("./Components/Bus/SearchBus.jsx"));
const BusResults = lazy(() => import("./Components/Bus/BusResults.jsx"));
const CompanyBankAccounts = lazy(() => import("./Components/Companies/CompanyBankAccounts.jsx"));
const TopUpHistory = lazy(() => import("./Components/Master/TopUpHistory.jsx"));
const TopUpRequest = lazy(() => import("./Components/Master/TopUpRequest.jsx"));
const FlightSupplierReport = lazy(() => import("./Components/Report/FlightSupplierReport.jsx"));
const BookingDetails = lazy(() => import("./Components/Bus/BookingDetails.jsx"));
const BusPayment = lazy(() => import("./Components/Bus/BusPayment.jsx"));
const BusBookings = lazy(() => import("./Components/Bus/BusBookings.jsx"));
const BusSeatSelection = lazy(() => import("./Components/Bus/BusSeatSelection.jsx"));
const SupplierDashboard = lazy(() => import("./Components/Dashboard/SupplierDashboard.jsx"));
const VisaDashboard = lazy(() => import("./Supplier/VisaDashboard.jsx"));
const HolidayDashboard = lazy(() => import("./Supplier/HolidayDashboard.jsx"));
const SaleInvoice = lazy(() => import("./Components/Accounts/Invoices/SaleInvoice.jsx"));
const EditSaleInvoice = lazy(() => import("./Components/Accounts/Invoices/EditSaleInvoice"));
const SaleView = lazy(() => import("./Components/Accounts/Invoices/SaleView"));
const SaleList = lazy(() => import("./Components/Accounts/Invoices/SaleList"));
const PurchaseInvoice = lazy(() => import("./Components/Accounts/Invoices/PurchaseInvoice"));
const PurchaseList = lazy(() => import("./Components/Accounts/Invoices/PurchaseList"));
const EditPurchaseInvoice = lazy(() => import("./Components/Accounts/Invoices/EditPurchaseInvoice"));
const PurchaseView = lazy(() => import("./Components/Accounts/Invoices/PurchaseView"));
const ExpenseInvoice = lazy(() => import("./Components/Accounts/Invoices/ExpenseInvoice"));
const ExpenseList = lazy(() => import("./Components/Accounts/Invoices/ExpenseList"));
const ExpenseView = lazy(() => import("./Components/Accounts/Invoices/ExpenseView"));
const EditExpenseInvoice = lazy(() => import("./Components/Accounts/Invoices/EditExpenseInvoice"));
const ExpenseReport = lazy(() => import("./Components/Accounts/Reports/ExpenseReport"));
const SalesReport = lazy(() => import("./Components/Accounts/Reports/SalesReport"));
const PurchasesReport = lazy(() => import("./Components/Accounts/Reports/PurchasesReport"));
const InvoiceReport = lazy(() => import("./Components/Accounts/Reports/InvoiceReport"));
const Cheque = lazy(() => import("./Components/Accounts/Reports/Cheque"));
const MarkupSetting = lazy(() => import("./Components/Master/MarkupSetting.jsx"));
const DMCPackageCreator = lazy(() => import("./DMC/DMCPackage/DMCPackageCreate.jsx"));
const DMCPackageList = lazy(() => import("./DMC/DMCPackage/DMCPackagesList.jsx"));
const DMCPackageDetails = lazy(() => import("./DMC/DMCPackage/DMCPackageDetails.jsx"));
const DMCDealsList = lazy(() => import("./DMC/DMCPackage/DMCDeals.jsx"));
const AccountDashboard = lazy(() => import("./Components/Dashboard/AccountDashboard.jsx"));
const SeriesFares = lazy(() => import("./Components/SeriesFare/SeriesFare.jsx"));
const SeriesFareAgentSearch = lazy(() => import("./Components/SeriesFare/AgentSearch.jsx"));
const SeriesFarePayment = lazy(() => import("./Components/SeriesFare/SeriesFarePayment.jsx"));
const SeriesFareBlockConfirmation = lazy(() => import("./Components/SeriesFare/SeriesFareBlockConfirmation.jsx"));
const AgentBookings = lazy(() => import("./Components/SeriesFare/AgentBookings.jsx"));
const DmcBlockRequests = lazy(() => import("./Components/SeriesFare/DmcBlockRequests.jsx"));
const DMCPackageEnquiry = lazy(() => import("./DMC/DMCPackage/DMCPackageEnquiry.jsx"));
const DMCPackagePDFCreator = lazy(() => import("./DMC/DMCPackage/DMCPackagePDFCreator.jsx"));
const SeriesFareDashboard = lazy(() => import("./Supplier/SeriesFares/SeriesFareDashboard.jsx"));
const SeriesFareList = lazy(() => import("./Components/SeriesFare/SeriesFareList.jsx"));
const BookingAccounting = lazy(() => import("./Components/MongoAccounts/BookingAccounting.jsx"));
const ProfitLossReport = lazy(() => import("./Components/MongoAccounts/ProfitLossReport.jsx"));
const ProfitLossDetailedReport = lazy(() => import("./Components/MongoAccounts/ProfitLossDetailedReport.jsx"));
const DMCList = lazy(() => import("./DMC/DMCList.jsx"));
const StatementOfAccount = lazy(() => import("./Components/MongoAccounts/StatementOfAccount.jsx"));
const SupplierLedger = lazy(() => import("./Components/MongoAccounts/SupplierLedger.jsx"));
const AgentLedger = lazy(() => import("./Components/MongoAccounts/AgentLedger.jsx"));
const MongoAccountingDashboard = lazy(() => import("./Components/MongoAccounts/MongoAccountingDashboard.jsx"));
const BookingEnquiries = lazy(() => import("./DMC/HotelDmc/BookingEnquiries.jsx"));
const HotelDashboard = lazy(() => import("./DMC/HotelDmc/HotelDashboard.jsx"));
const FlightManualVoucherGenerator = lazy(() => import("./Components/Flight/FlightManualVoucherGenerator.jsx"));
const PublicFaq = lazy(() => import("./Common/Layout/PublicFaq.jsx"));
const AgentWebsiteShowcase = lazy(() => import("./Website/AgentWebsiteShowcase.jsx"));
const HotelDMCProperties = lazy(() => import("./DMC/HotelDmc/HotelDMCProperties.jsx"));
const PropertiesList = lazy(() => import("./DMC/HotelDmc/PropertiesList.jsx"));
const TBOSupplierHighlight = lazy(() => import("./SuppliersInfo/TboInfo.jsx"));
const TripjackSupplierHighlight = lazy(() => import("./SuppliersInfo/TripJackInfo.jsx"));
const AkbarTravelsSupplierHighlight = lazy(() => import("./SuppliersInfo/AkbarInfo.jsx"));
const RezLiveSupplierHighlight = lazy(() => import("./SuppliersInfo/RezLive.jsx"));
const GRNConnectSupplierHighlight = lazy(() => import("./SuppliersInfo/GRNInfo"));
const RiyaTravelSupplierHighlight = lazy(() => import("./SuppliersInfo/Riya.jsx"));
const ViatorSupplierHighlight = lazy(() => import("./SuppliersInfo/ViatorInfo.jsx"));
const AirIQSupplierHighlight = lazy(() => import("./SuppliersInfo/AirIQInfo.jsx"));
const DmcEnquiryList = lazy(() => import("./DMC/DMCPackage/DmcEnquiryList.jsx"));
const Employee = lazy(() => import("./Components/Master/Employee.js"));
const TeamOutingRequest = lazy(() => import("./Components/CorporateB2EScreens/TeamOutingRequest.jsx"));
const GroupTourAdmin = lazy(() => import("./Components/CorporateB2EScreens/GroupTourRequest.jsx"));
const CompanyAgents = lazy(() => import("./Components/Master/Agents/CompanyAgents.jsx"));
const AgentWallet = lazy(() => import("./Components/Master/Agents/AgentWallet.jsx"));
const DMCPackageDetailsForAgents = lazy(() => import("./DMC/DMCPackage/DMCPackageDetailsForAgents.jsx"));
const CompanyCorporate = lazy(() => import("./Components/Master/Agents/CompanyCorporate.jsx"));
const CorporateWallet = lazy(() => import("./Components/Master/Agents/CorporateWallet.jsx"));
const AccountItem = lazy(() => import("./Components/Accounts/Invoices/AccountItem.jsx"));
const Item = lazy(() => import("./Components/Accounts/Invoices/Item.jsx"));
const BusForm = lazy(() => import("./Components/Bus/BusForm.jsx"));
const MyPlan = lazy(() => import("./Components/Master/MyPlan.jsx"));
const FlightB2CBookings = lazy(() => import("./Components/Flight/FlightB2CBookings"));
const FlightAgentBookings = lazy(() => import("./Components/Flight/FlightAgentBookings"));
const FlightCorporateBookings = lazy(() => import("./Components/Flight/FlightCorporateBookings"));
const SightSeeingB2BBookings = lazy(() => import("./Components/SightSeeing/SightSeeingB2BBookings"));
const SightSeeingB2CBookings = lazy(() => import("./Components/SightSeeing/SightSeeingB2CBookings"));
const SightSeeingB2EBookings = lazy(() => import("./Components/SightSeeing/SightSeeingB2EBookings"));
const SocialMediaSettings = lazy(() => import("./Components/Marketing/SocialMediaAccount.jsx"));
const Contacts = lazy(() => import("./Components/Marketing/Contacts.jsx"));
const TemplatesDisplay = lazy(() => import("./Website/TemplateDisplay.jsx"));
const ClientVisaPrices = lazy(() => import("./Components/Visas/ClientVisaPrices.jsx"));
const TemplatePreviewPage = lazy(() => import("./Components/Package/TemplatePreviewPage.jsx"));
const FlightSupplierPayableReport = lazy(() => import("./Components/Report/FlightSupplierPayableReport.jsx"));
const PortalSetUpSteps = lazy(() => import("./StaticPages/PortalSetUpSteps.jsx"));
const HotelManualVoucherGenerator = lazy(() => import("./Components/Hotels/HotelManualVoucherGenerator.jsx"));
const HotelGstReport = lazy(() => import("./Components/Report/HotelGstReport.jsx"));
const HotelSupplierPayableReport = lazy(() => import("./Components/Report/HotelSupplierPayableReport.jsx"));
const VisaReport = lazy(() => import("./Components/Report/VisaReport.jsx"));
const VisaGstReport = lazy(() => import("./Components/Report/VisaGstReport.jsx"));
const CompanyDocuments = lazy(() => import("./Components/Companies/CompanyDocuments.jsx"));
const VisaInvoice = lazy(() => import("./Components/Visas/VisaInvoice.jsx"));
const VisaVoucher = lazy(() => import("./Components/Visas/VisaVoucher.jsx"));
const SightseeingMasterSearch = lazy(() => import("./DMC/SightSeeingDMC/SightseeingMasterSearch.jsx"));
const SightseeingDeals = lazy(() => import("./DMC/SightSeeingDMC/SightseeingDeals.jsx"));
const BusReport = lazy(() => import("./Components/Report/BusReport.jsx"));
const BusGstReport = lazy(() => import("./Components/Report/BusGstReport.jsx"));
const BusSupplierPayableReport = lazy(() => import("./Components/Report/BusSupplierPayableReport.jsx"));
const PackageMasterSearch = lazy(() => import("./DMC/DMCPackage/PackageMasterSearch.jsx"));
const MasterPackageCreate = lazy(() => import("./Components/GlobalPackage/MaterPackageCreate.jsx"));
const PackagePreviewPage = lazy(() => import("./Components/GlobalPackage/PackagePreviewPage.jsx"));
const MasterPackagesList = lazy(() => import("./Components/GlobalPackage/MasterPackageList.jsx"));
const MasterPackageDetails = lazy(() => import("./Components/GlobalPackage/MasterPackageDetails.jsx"));
const CompanyPackagesList = lazy(() => import("./Components/GlobalPackage/CompanyPackagesList.jsx"));
const CompanyPackageDetails = lazy(() => import("./Components/GlobalPackage/CompanyPackageDetails.jsx"));
const CompanyPackageEdit = lazy(() => import("./Components/GlobalPackage/CompanyPackageEdit.jsx"));
const DMCDeals = lazy(() => import("./Components/GlobalPackage/DMCDeals.jsx"));
const FlightAiPackageCreate = lazy(() => import("./Components/GlobalPackage/AIPackages/FlightAiPackageCreate.jsx"));
const LandAiPackageCreate = lazy(() => import("./Components/GlobalPackage/AIPackages/LandAiPackageCreate.jsx"));
const DmcPackageDetails = lazy(() => import("./Components/GlobalPackage/DmcPackageDetails.jsx"));
const PaymentGateway = lazy(() => import("./Components/Master/PaymentGateway"));
const CustomerPackagesList = lazy(() => import("./Components/GlobalPackage/CustomerPackagesList.jsx"));
const CustomerPackageCreateEdit = lazy(() => import("./Components/GlobalPackage/CustomerPackageCreateEdit.jsx"));
const CustomerPackageDetails = lazy(() => import("./Components/GlobalPackage/CustomerPackageDetails.jsx"));
const CustomerFlightInvoice = lazy(() => import("./Components/Flight/CustomerFlightInvoice.jsx"));
const BusVoucher = lazy(() => import("./Components/Bus/BusVoucher.jsx"));
const BusCustomerInvoice = lazy(() => import("./Components/Bus/BusCustomerInvoice.jsx"));
const BusAgentInvoice = lazy(() => import("./Components/Bus/BusAgentInvoice.jsx"));
const BusDownload = lazy(() => import("./Components/Bus/BusDownload.jsx"));
const CustomerHotelInvoice = lazy(() => import("./Components/Hotels/CustomerHotelInvoice.jsx"));
const MySubscriptionList = lazy(() => import("./Components/Companies/MySubscriptionsList.jsx"));
// import HotelB2BBookings from "./Components/Hotels/HotelB2BBookings";
// import HotelB2CBookings from "./Components/Hotels/HotelB2CBookings";
// import HotelB2EBookings from "./Components/Hotels/HotelB2EBookings";

const Testimonial = lazy(() => import("./Components/Master/Testimonial.jsx"));
const Review = lazy(() => import("./Components/Master/Review"));
const TestimonialsSection = lazy(() => import("./StaticPages/TestimonialsSection.jsx"));
const Blog = lazy(() => import("./Components/Master/Blog.jsx"));
const MasterAccountingBook = lazy(() => import("./Components/MongoAccounts/MasterAccountingBook.jsx"));
const CreditNoteList = lazy(() => import("./Components/MongoAccounts/CreditNoteList.jsx"));
const DebitNoteList = lazy(() => import("./Components/MongoAccounts/DebitNoteList.jsx"));
const JournalEntryList = lazy(() => import("./Components/MongoAccounts/JournalEntryList.jsx"));
const CreditNoteView = lazy(() => import("./Components/MongoAccounts/CreditNoteView.jsx"));
const DebitNoteView = lazy(() => import("./Components/MongoAccounts/DebitNoteView.jsx"));
const CommissionsList = lazy(() => import("./Components/MongoAccounts/CommissionsList.jsx"));
const BankPassbook = lazy(() => import("./Components/MongoAccounts/BankPassbook.jsx"));
const StatutoryTaxReport = lazy(() => import("./Components/MongoAccounts/StatutoryTaxReport.jsx"));
const TrialBalance = lazy(() => import("./Components/MongoAccounts/TrialBalance.jsx"));
const PackageEnquiryList = lazy(() => import("./Components/GlobalPackage/PackageEnquiryList.jsx"));
const DMCVehicle = lazy(() => import("./DMC/DMCTransfer/DMCVehicle.jsx"));
const DMCVehiclePricing = lazy(() => import("./DMC/DMCTransfer/DMCVehiclePricing.jsx"));
const DMCVehicleDriver = lazy(() => import("./DMC/DMCTransfer/DMCVehicleDriver.jsx"));
const DMCTransferBookings = lazy(() => import("./DMC/DMCTransfer/DMCTransferBookings.jsx"));
const DMCTransferBookingDetails = lazy(() => import("./DMC/DMCTransfer/DMCTransferBookingDetails.jsx"));
 const DMCTransferDownload= lazy(() => import("./DMC/DMCTransfer/DMCTransferDownload.jsx"));
const DMCTransferVoucher =lazy(() => import("./DMC/DMCTransfer/DMCTransferVoucher.jsx"));
const DMCTransferCustomerInvoice =lazy(() => import("./DMC/DMCTransfer/DMCTransferCustomerInvoice.jsx"));
const TransferDMCInvoice =lazy(() => import("./DMC/DMCTransfer/TransfeDMCInvoice.jsx"));
const CompanyDestination = lazy(() => import("./Components/Companies/CompanyDestination.jsx"));
const SearchInsurance = lazy(() => import("./Components/Insurance/SearchInsurance.jsx"));
const InsurancePlansList = lazy(() => import("./Components/Insurance/InsurancePlansList.jsx"));
const InsuranceReviewBooking = lazy(() => import("./Components/Insurance/InsuranceReviewBooking.jsx"));
const InsuranceBookings = lazy(() => import("./Components/Insurance/InsuranceBookings.jsx"));
const InsuranceConfirmation = lazy(() => import("./Components/Insurance/InsuranceConfirmation.jsx"));
const InsuranceVoucher = lazy(() => import("./Components/Insurance/InsuranceVoucher.jsx"));
const InsuranceInvoice = lazy(() => import("./Components/Insurance/InsuranceInvoice.jsx"));
const CustomerInsuranceInvoice = lazy(() => import("./Components/Insurance/CustomerInsuranceInvoice.jsx"));
const DMCTransferReview = lazy(() => import("./Components/Transfer/DMCTransferReview.jsx"));

const TransferSearch = lazy(() => import("./Components/Transfer/TransferSearch.jsx"));
const TransferResults = lazy(() => import("./Components/Transfer/TransferResults.jsx"));
const TransferBookings = lazy(() => import("./Components/Transfer/TransferBookings.jsx"));
const TransferReview = lazy(() => import("./Components/Transfer/TransferReview.jsx"));
const TransferBookingDetails = lazy(() => import("./Components/Transfer/TransferBookingDetails.jsx"));
const TransferVoucher = lazy(() => import("./Components/Transfer/TransferVoucher.jsx"));
const TransferCustomerInvoice = lazy(() => import("./Components/Transfer/TransferCustomerInvoice.jsx"));
const TransferAgentInvoice = lazy(() => import("./Components/Transfer/TransferAgentInvoice.jsx"));
const TransferDownload = lazy(() => import("./Components/Transfer/TransferDownload.jsx"));
const DMCVisaPrices  = lazy(() => import("./DMC/DMCVisa/DMCVisaPrices.jsx"));




function App() {
  return (
    <>
      <Suspense fallback={<div className="page-loading-fallback" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>Loading...</div>}>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<SaasRegister />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/booking-terms-and-conditions" element={<BookingTermsAndConditions />} />
            <Route path="/supplierregister" element={<SupplierRegister />} />
            <Route path="/dmcregister" element={<DMCRegistration />} />
            <Route path="/visaregister" element={<VisaProviders />} />
            <Route path="/faq" element={<PublicFaq />} />
            <Route path="/suppliertaxinformation" element={<SupplierTaxInformation />} />
            <Route path="/tax-information" element={<TaxInformation />} />
            <Route path="/registration-pending" element={<RegistrationPending />} />
            <Route path="/confirm-email" element={<ConfirmEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            {/* supplier information  */}
            <Route path="/supplier/trip-jack" element={<TripjackSupplierHighlight />} />
            <Route path="/supplier/tbo" element={<TBOSupplierHighlight />} />
            <Route path="/supplier/akbar-travels" element={<AkbarTravelsSupplierHighlight />} />
            <Route path="/supplier/rezlive" element={<RezLiveSupplierHighlight />} />
            <Route path="/supplier/grn-connect" element={<GRNConnectSupplierHighlight />} />
            <Route path="/supplier/riya-travel" element={<RiyaTravelSupplierHighlight />} />
            <Route path="/supplier/viator" element={<ViatorSupplierHighlight />} />
            <Route path="/supplier/air-iq" element={<AirIQSupplierHighlight />} />
            <Route path="/travel-websites" element={<TemplatesDisplay />} />
            <Route path="/portal-setup" element={<PortalSetUpSteps />} />
          </Route>
          <Route element={<AppLayout />}>
            <Route path="/flight/search" element={<SearchFlight />} />
            <Route path="/flight/compare" element={<SearchCompareFlight />} />
            <Route path="/hotel/search" element={<SearchHotel />} />
            <Route path="/sightseeing/search" element={<SightSeeingSearch />} />
            <Route path="/umrah" element={<Umrah />} />
            <Route path="/packageslist" element={<PackageList />} />
            <Route path="/hajjList" element={<HajjList />} />
            <Route path="/login" element={<Login />} />
            <Route path="/subscriptionplans" element={<SubscriptionPlan />} />
            {/* <Route path="/myplan" element={<MySubscriptionPlan />} /> */}
            <Route path="/myplan" element={<MyPlan />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/companyprofile" element={<CompanyProfile />} />
            <Route path="/branchs" element={<Branch />} />
            <Route path="/users" element={<Users />} />
            <Route path="/employee" element={<Employee />} />
            <Route path="/companybankaccounts" element={<CompanyBankAccounts />} />
            <Route path="/leadstatus" element={<LeadStatus />} />
            <Route path="/source" element={<Source />} />
            <Route path="/leads" element={<Lead />} />
            <Route path="/leaddashboard" element={<LeadManagementDashboard />} />
            <Route path="/lead/staffreports" element={<LeadStaffReports />} />
            <Route path="/suppliers" element={<Supplier />} />
            <Route path="/changepassword" element={<ChangePassword />} />
            <Route path="/promotion" element={<Promotions />} />
            <Route path="/flights/:adults?/:kids?/:infants?/:isDomestic?" element={<Flights />} />
            <Route path="/flights/compare/:adults?/:kids?/:infants?/:isDomestic?" element={<FlightsCompare />} />
            <Route path="/flightdetails/:adults?/:kids?/:infants?/:isDomestic?" element={<FlightDetails />} />
            <Route path="/flight/review/:adults?/:kids?/:infants?/:isDomestic?" element={<ReviewFlight />} />
            <Route path="/flight/bookings" element={<FlightBookings />} />
            <Route path="/flight/b2cbookings" element={<FlightB2CBookings />} />
            <Route path="/flight/agentbookings" element={<FlightAgentBookings />} />
            <Route path="/flight/corporatebookings" element={<FlightCorporateBookings />} />
            <Route path="/flight/booking/:flightBookingId" element={<FlightBookingDetails />} />
            <Route path="/flight/voucher/:flightBookingId" element={<FlightVoucher />} />
            <Route path="/flight/invoice/:flightBookingId" element={<FlightInvoice />} />
            <Route path="/flight/customer-invoice/:flightBookingId" element={<CustomerFlightInvoice />} />
            <Route path="/flight/supplierreport" element={<FlightSupplierReport />} />
            <Route path="/hotels" element={<HotelsList />} />
            <Route path="/hotel/details" element={<HotelDetails />} />
            <Route path="/hotel/guests" element={<HotelGuests />} />
            <Route path="/hotel/review" element={<HotelReview />} />
            <Route path="/hotel/bookings" element={<HotelBookings />} />
            <Route path="/hotel/booking/:hotelBookingId" element={<HotelBookingDetails />} />
            <Route path="/hotel/voucher/:hotelBookingId" element={<HotelVoucher />} />
            <Route path="/hotel/invoice/:hotelBookingId" element={<HotelInvoice />} />
            <Route path="/hotel/customer-invoice/:hotelBookingId" element={<CustomerHotelInvoice />} />
            {/* <Route path="/hotel/b2b-bookings" element={<HotelB2BBookings />} />
          <Route path="/hotel/b2c-bookings" element={<HotelB2CBookings />} />
          <Route path="/hotel/b2e-bookings" element={<HotelB2EBookings />} /> */}
            <Route path="/sightseeing/products/:destinationCode/:destination/:adults?/:kids?/:travelDate" element={<SightSeeingProducts />} />
            <Route path="/sightseeing/product/:productId/:destinationCode/:destination/:adults?/:kids?/:travelDate" element={<SightSeeingProduct />} />
            <Route path="/sightseeing/booking/:productId/:destinationCode/:destination/:adults?/:kids?/:infants?/:travelDate" element={<SightSeeingBooking />} />
            <Route path="/sightseeing/booking/:sightSeeingBookingId" element={<SightSeeingBookingDetails />} />
            <Route path="/sightseeing/bookings" element={<SightSeeingBookings />} />
            <Route path="/sightseeing/b2b-bookings" element={<SightSeeingB2BBookings />} />
            <Route path="/sightseeing/b2c-bookings" element={<SightSeeingB2CBookings />} />
            <Route path="/sightseeing/b2e-bookings" element={<SightSeeingB2EBookings />} />
            <Route path="/destinationtypes" element={<DestinationType />} />
            <Route path="/destinations" element={<Destination />} />
            <Route path="/traveltypes" element={<TravelType />} />
            <Route path="/package/:packageId?" element={<PackageComponent />} />
            <Route path="/packagedetails/:packageId" element={<PackageTemplates />} />
            <Route path="/websitepackages" element={<WebsitePackageList />} />
            <Route path="/websiteumrahpackages" element={<WebsiteUmrahList />} />
            <Route path="/websitehajjpackages" element={<WebsiteHajjList />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/customers" element={<Customer />} />
            <Route path="/leadcalendar" element={<LeadCalendar />} />
            <Route path="/packagedates" element={<PackageDate />} />
            <Route path="/orign" element={<FromOrigin />} />
            <Route path="/enquirylist" element={<EnquiryList />} />
            <Route path="/landingpage" element={<LandingPage />} />
            <Route path="/groupbookings" element={<GroupBookings />} />
            <Route path="/umrahList" element={<UmrahList />} />
            <Route path="/umrahpackage/:packageId?" element={<Umrah />} />
            <Route path="/umrahenquiry" element={<UmrahEnquiryList />} />
            <Route path="/hajjpackage/:packageId?" element={<Hajj />} />
            <Route path="/hajj" element={<Hajj />} />
            <Route path="/hajjenquiry" element={<HajjEnquiry />} />
            <Route path="/flight/report" element={<FlightReport />} />
            <Route path="/flightsupplierreport" element={<FlightSupplierReport />} />
            <Route path="/hotel/report" element={<HotelReport />} />
            <Route path="/flight/gstreport" element={<FlightGstReport />} />
            <Route path="/agent/payments" element={<AgentPayments />} />
            <Route path="/agent/credits" element={<AgentCredits />} />
            <Route path="/agent/invoices" element={<AgentInvoice />} />
            <Route path="/visarequestreport" element={<VisaRequestReports />} />
            <Route path="/visasupplierreport" element={<VisaSupplierReports />} />
            <Route path="/supplier/visaprices" element={<SupplierVisaPrices />} />
            <Route path="/supplier/visarequests" element={<SupplierVisaRequests />} />
            <Route path="/supplier/visaappointments" element={<VisaAppointments />} />
            <Route path="visaappointments" element={<VisaAppointmentCalendar />} />
            <Route path="/credithistory" element={<CreditHistory />} />
            <Route path="/topuphistory" element={<TopUpHistory />} />
            <Route path="/topuprequest" element={<TopUpRequest />} />
            <Route path="/chatbot" element={<ChatBotSettings />} />
            <Route path="/whatsapp-callback" element={<WhatsAppCallback />} />
            <Route path="/visas" element={<Visas />} />
            <Route path="/request/:visaRequestId" element={<RequestDetails />} />
            <Route path="/requests" element={<Requests />} />
            <Route path="/bus/search" element={<BusSearch />} />
            <Route path="/bus/results" element={<BusResults />} />
            <Route path="/bus/seats" element={<BusSeatSelection />} />
            <Route path="/bus/payment" element={<BusPayment />} />
            <Route path="/bus/bookings" element={<BusBookings />} />
            <Route path="/bus/form" element={<BusForm />} />
            <Route path="/bus/booking/:bookingId" element={<BookingDetails />} />
            <Route path="/bus/voucher/:bookingId" element={<BusVoucher />} />
            <Route path="/bus/download/:bookingId" element={<BusDownload />} />
            <Route path="/bus/customer-invoice/:bookingId" element={<BusCustomerInvoice />} />
            <Route path="/bus/agent-invoice/:bookingId" element={<BusAgentInvoice />} />
            <Route path="/bus/report" element={<BusReport />} />
            <Route path="/bus/gstreport" element={<BusGstReport />} />
            <Route path="/bus/supplier-payable-report" element={<BusSupplierPayableReport />} />
            <Route path="/supplierdashboard" element={<SupplierDashboard />} />
            <Route path="/visadashboard" element={<VisaDashboard />} />
            <Route path="/holidaydashboard" element={<HolidayDashboard />} />
            <Route path="/saleinvoice" element={<SaleInvoice />} />
            <Route path="/editsaleinvoice/:invoiceId" element={<EditSaleInvoice />} />
            <Route path="/sale/view/:invoiceId" element={<SaleView />} />
            <Route path="/salelist" element={<SaleList />} />
            <Route path="/purchaseinvoice" element={<PurchaseInvoice />} />
            <Route path="purchaselist" element={<PurchaseList />} />
            <Route path="/purchase/view/:invoiceId" element={<PurchaseView />} />
            <Route path="/editpurchaseinvoice/:invoiceId" element={<EditPurchaseInvoice />} />
            <Route path="/expenseinvoice" element={<ExpenseInvoice />} />
            <Route path="expenselist" element={<ExpenseList />} />
            <Route path="/expense/view/:invoiceId" element={<ExpenseView />} />
            <Route path="/editexpenseinvoice/:invoiceId" element={<EditExpenseInvoice />} />
            <Route path="/expensesReport" element={<ExpenseReport />} />
            <Route path="/salesReport" element={<SalesReport />} />
            <Route path="/purchasesReport" element={<PurchasesReport />} />
            <Route path="/invoiceReport" element={<InvoiceReport />} />
            <Route path="/cheques" element={<Cheque />} />
            <Route path="/markup-setting" element={<MarkupSetting />} />
            <Route path="/dmcpackagecreate" element={<DMCPackageCreator />} />
            <Route path="/dmcpackageslist" element={<DMCPackageList />} />
            <Route path="/dmcpackageview/:id" element={<DMCPackageDetails />} />
            <Route path="/dmcpackagedetails/:id" element={<DMCPackageDetailsForAgents />} />
            <Route path="/dmcpackagesdeals" element={<DMCDealsList />} />
            <Route path="/dmcpackageenquiries" element={<DMCPackageEnquiry />} />
            <Route path="/dmccreate-pdf" element={<DMCPackagePDFCreator />} />
            <Route path="/accounts/dashboard" element={<AccountDashboard />} />
            <Route path="/seriesfare" element={<SeriesFares />} />
            <Route path="/seriesfare/agent-search" element={<SeriesFareAgentSearch />} />
            <Route path="/seriesfare/dashboard" element={<SeriesFareDashboard />} />
            <Route path="/seriesfarelist" element={<SeriesFareList />} />
            <Route path="/seriesfare-payment" element={<SeriesFarePayment />} />
            <Route path="/seriesfare/blockconfirmation" element={<SeriesFareBlockConfirmation />} />
            <Route path="/seriesfare/agentbookings" element={<AgentBookings />} />
            <Route path="/seriesfare/blockrequest" element={<DmcBlockRequests />} />
            <Route path="/team-outing-requests" element={<TeamOutingRequest />} />
            <Route path="/group-tour-requests" element={<GroupTourAdmin />} />
            <Route path="/flight/booking-accounting/:bookingId" element={<BookingAccounting />} />
            <Route path="/profit-loss-report" element={<ProfitLossReport />} />
            <Route path="/profit-loss-detailedreport" element={<ProfitLossDetailedReport />} />
            <Route path="/dmc-list" element={<DMCList />} />
            <Route path="/statement-of-account" element={<StatementOfAccount />} />
            <Route path="/supplier-ledger" element={<SupplierLedger />} />
            <Route path="/agent-ledger" element={<AgentLedger />} />
            <Route path="/accounts-dashboard" element={<MongoAccountingDashboard />} />
            <Route path="/hotel/enquiries" element={<BookingEnquiries />} />
            <Route path="/hoteldashboard" element={<HotelDashboard />} />
            <Route path="/myproperties" element={<HotelDMCProperties />} />
            <Route path="/properties" element={<PropertiesList />} />
            <Route path="/flight/voucher-generator" element={<FlightManualVoucherGenerator />} />
            <Route path="/dmcpackageenquirylist" element={<DmcEnquiryList />} />
            <Route path="/agent-website-showcase" element={<AgentWebsiteShowcase />} />
            <Route path="/company/agents" element={<CompanyAgents />} />
            <Route path="/agentwallet" element={<AgentWallet />} />
            <Route path="/company/corporate" element={<CompanyCorporate />} />
            <Route path="/corporatewallet" element={<CorporateWallet />} />
            <Route path="/accountitems" element={<AccountItem />} />
            <Route path="/items" element={<Item />} />
            <Route path="/socialmediasettings" element={<SocialMediaSettings />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/create/visaprices" element={<ClientVisaPrices />} />
            <Route path="/flight/supplier-payable-report" element={<FlightSupplierPayableReport />} />
            <Route path="/hotel/voucher-generator" element={<HotelManualVoucherGenerator />} />
            <Route path="/hotel/gstreport" element={<HotelGstReport />} />
            <Route path="/hotel/supplier-payable-report" element={<HotelSupplierPayableReport />} />
            <Route path="/visa/report" element={<VisaReport />} />
            <Route path="/visa/gstreport" element={<VisaGstReport />} />
            <Route path="/visa/invoice/:visaRequestId" element={<VisaInvoice />} />
            <Route path="/visa/voucher/:visaRequestId" element={<VisaVoucher />} />
            <Route path="/company-documents" element={<CompanyDocuments />} />
            <Route path="/activities" element={<SightseeingMasterSearch />} />
            <Route path="/sightseeing/deals" element={<SightseeingDeals />} />
            <Route path="/mypackages" element={<PackageMasterSearch />} />
            <Route path="/createpackage" element={<MasterPackageCreate />} />
            <Route path="/__verify_createpackage" element={
              <VerifyAuthContext.Provider value={{ user: { id: 'u1', cid: 'c1', name: 'Test User', email: 'test@example.com', phoneNumber: '9999999999', companyType: 'Manual' }, loading: false, refreshUserProfile: async () => ({ connects: 5 }) }}>
                <MasterPackageCreate />
              </VerifyAuthContext.Provider>
            } />
            <Route path="/package-preview" element={<PackagePreviewPage />} />
            <Route path="/masterpackages" element={<MasterPackagesList />} />
            <Route path="/packages/view/:id" element={<MasterPackageDetails />} />
            <Route path="/companypackages" element={<CompanyPackagesList />} />
            <Route path="/packages/view-company/:id" element={<CompanyPackageDetails />} />
            <Route path="/packages/edit/:id" element={<CompanyPackageEdit />} />
            <Route path="/flight-ai-packagecreate" element={<FlightAiPackageCreate />} />
            <Route path="/land-ai-packagecreate" element={<LandAiPackageCreate />} />
            <Route path="/zotraipackages" element={<DMCDeals />} />
            <Route path="/zotraipackages/view/:id" element={<DmcPackageDetails />} />
            <Route path="/customerpackages" element={<CustomerPackagesList />} />
            <Route path="/packages/customer/create" element={<CustomerPackageCreateEdit />} />
            <Route path="/packages/edit-customer/:id" element={<CustomerPackageCreateEdit />} />
            <Route path="/packages/view-customer/:id" element={<CustomerPackageDetails />} />
            <Route path="/paymentgateways" element={<PaymentGateway />} />
            <Route path="/promocodes" element={<PromoCode />} />
            <Route path="/my-subscriptionslist" element={<MySubscriptionList />} />
            <Route path="/creditnotelist" element={<CreditNoteList />} />
            <Route path="/debitnotelist" element={<DebitNoteList />} />
            <Route path="/journalentry" element={<JournalEntryList />} />
            <Route path="/creditnote/view/:id" element={<CreditNoteView />} />
            <Route path="/debitnoteview/:id" element={<DebitNoteView />} />
            <Route path="/commissions" element={<CommissionsList />} />
            <Route path="/accountbook" element={<BankPassbook />} />
            <Route path="/statutorygst-report" element={<StatutoryTaxReport />} />
            <Route path="/trialbalance" element={<TrialBalance />} />
            <Route path="/package/enquirylist" element={<PackageEnquiryList />} />
            <Route path="/company/destinations" element={<CompanyDestination />} />
            <Route path="/dmc/vehicles" element={<DMCVehicle />} />
            <Route path="/dmc/vehicle-pricing" element={<DMCVehiclePricing />} />
            <Route path="/dmc-vehicle-driver"element={<DMCVehicleDriver />}/>
            <Route path="/dmc/transfer/review" element={<DMCTransferReview />} />
            <Route path="/dmc-transfer/bookings" element={<DMCTransferBookings />} />
            <Route path="/dmc-transfer/confirmation/:transferBookingId" element={<DMCTransferBookingDetails />}/>
             <Route path="/dmc-transfer/voucher/:transferBookingId" element={<DMCTransferVoucher />} />
             <Route path="/dmc-transfer/agent-invoice/:transferBookingId" element={<DMCTransferCustomerInvoice />} />
            <Route path="/dmc-transfer/invoice/:transferBookingId" element={<TransferDMCInvoice />} />
            <Route path="/dmc-transfer/download/:transferBookingId" element={<DMCTransferDownload />} />

            <Route path="/transfer/search" element={<TransferSearch />} />
            <Route path="/transfer/search/results" element={<TransferResults />} />
            <Route path="/transfer/review" element={<TransferReview />} />
            <Route path="/transfer/bookings" element={<TransferBookings />} />
            <Route path="/transfer/confirmation/:transferBookingId" element={<TransferBookingDetails />} />
            <Route path="/transfer/voucher/:transferBookingId" element={<TransferVoucher />} />
            <Route path="/transfer/customer-invoice/:transferBookingId" element={<TransferCustomerInvoice />} />
            <Route path="/transfer/agent-invoice/:transferBookingId" element={<TransferAgentInvoice />} />
            <Route path="/transfer/download/:transferBookingId" element={<TransferDownload />} />
             <Route path="/create/visa/prices" element={<DMCVisaPrices/>} />

          



            <Route path="/insurance" element={<SearchInsurance />} />
            <Route path="/insurance/plans" element={<InsurancePlansList />} />
            <Route path="/insurance/review" element={<InsuranceReviewBooking />} />
            <Route path="/insurance/confirmation/:id" element={<InsuranceConfirmation />} />
            <Route path="/insurance/bookings" element={<InsuranceBookings />} />
            <Route path="/insurance/voucher/:id" element={<InsuranceVoucher />} />
            <Route path="/insurance/invoice/:id" element={<InsuranceInvoice />} />
            <Route path="/insurance/customer-invoice/:id" element={<CustomerInsuranceInvoice />} />
          </Route>

          <Route path="/template-preview/:packageId/:templateId" element={<TemplatePreviewPage />} />
          <Route path="/holidaydashboard" element={<HolidayDashboard />} />
          <Route path="/companytestimonials" element={<Testimonial />} />
          <Route path="/companyreviews" element={<Review />} />
          <Route path="/blogs" element={<Blog />} />
        </Routes>
      </Suspense>
      <ToastContainer position="top-right" autoClose={3000} />
    </>



  );
}

export default App;
